/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import {
  Collapse,
  Image,
  Modal,
  Input,
  Select,
  Form,
  Upload,
  Checkbox,
  message,
  notification,
  Radio,
  Spin,
} from "antd";
import Cookies from "js-cookie";
import { DownloadOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { setJobProgressHistory } from "../../../../actions/jobDetailAction";
import { setJobProgressDetailPic } from "../../../../actions/jobProgressdetailPicAction";
import ServiceApi, { authUser } from "../../../../services/ServiceApi";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import {
  defaultFormItemLayout,
  tailLayout,
} from "../../../utility/form_layout";
import axios from "axios";

const { Option, OptGroup } = Select;
const { Panel } = Collapse;
const Jobprocesscard = (
  { title, date, time, detail, job_progress_detail_id, create_by_name },
  jobProgressPic
) => {
  return (
    <>
      <div className="card-header c-blue px-2 py-1">
        <i className="fa fa-circle fa-xs mr-2"></i>
        {title}
        {/* {TagLabel(flag)} */}
        <span className="float-right">
          {date} {time}
        </span>
      </div>
      <div className="card-body py-2">
        <div className="row">
          <div className="col-lg-7">
            <p className="card-text">{detail}</p>
            <p className="card-text">{`Create By ${create_by_name}`}</p>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="mr-4" style={{ cursor: "pointer" }}>
                <Image.PreviewGroup>
                  {jobProgressPic?.map((data, index) => {
                    if (
                      data.reference_id === job_progress_detail_id &&
                      data.pic_type === "P"
                    ) {
                      return (
                        <Image
                          width={150}
                          height={80}
                          key={`img_index_${index}`}
                          src={ServiceApi.checkPath(
                            data.pic_url_path,
                            data.pic_upload_name
                          )}
                        ></Image>
                      );
                    }
                  })}
                </Image.PreviewGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default function Jobprocess(props) {
  const { CompanyId, OperatorId, ProjectId, jobData } = props;
  const [formData, setFormData] = useState({
    activityType: [],
    progressDetailType: [],
    progressDetail: "",
    photoandVideo: "",
  });
  const [externalUrl, setexternalUrl] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobAssetdetail] = jobData.result_assetdetail ?? [null];
  const [jobStopTime] = jobData.result_stop_time ?? [null];
  const [pStateFilter, setpStateFilter] = useState(false);
  const [displayModal, setdisplayModal] = useState(false);
  const [jobDetail] = jobData.result_job_detail ?? [null];
  const [dataEdit, setDataEdit] = useState({});
  const [visibleModal, setVisibleModal] = useState(true);
  const [loadingText, setloadingText] = useState("Loading");
  const [form] = Form.useForm();
  //const operJobpic = jobData.result_oper_job_pic;
  const { jobProgressPic } = useSelector((state) => ({
    jobProgressPic: state.jobProgressPic.jobProgressPic,
  }));
  const auth = authUser();
  const dispatch = useDispatch();
  const { jobProgressHistory } = useSelector((state) => ({
    jobProgressHistory: state.jobDetail.jobProgressHistory,
  }));
  console.log("jobStopTime", jobStopTime);

  useEffect(() => {
    setLoading(true);
    ServiceApi.post("job_detail/job_progress_detail_list", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_progress_detail_id: "0",
      job_progress_id: jobAssetdetail?.job_progress_id,
      job_id: jobAssetdetail?.job_id,
    })
      .then((res) => {
        const progressList = res.data.data?.job_progress_detail;
        const oper_pic = res.data.data?.result_oper_pic;
        // .filter(b => b.job_id === jobAssetdetail?.job_id)
        const records = progressList
          // ?.filter((b) => b.problem_detail)
          .filter((b) => b.job_id === jobAssetdetail?.job_id)
          .map((s) => ({
            ...s,
            title: s.progress_type_Detail || "N/A",
            flag: s.progress_status_flag || "N/A",
            date: moment(s.update_date).format("DD/MM/YYYY"),
            time: moment(s.update_date).format("HH:mm"),
            detail: s.progress_detail || "N/A",
            createby: s.create_by_name || "System",
          }));
        dispatch(setJobProgressHistory(records));
        dispatch(setJobProgressDetailPic(oper_pic));
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [auth.companyId, auth.operatorId, auth.projectId, jobAssetdetail]);

  const genDownloadCSV = () => (
    <DownloadOutlined
      title="Export CSV"
      className="mr-3"
      onClick={(event) => {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
      }}
    />
  );

  const onEdit = (data, image) => {
    setDataEdit(data);
    form.setFieldsValue({
      activity_type: data.activity_id,
      progress_detail: data.progress_detail_type_id,
      progress_details: data.progress_detail,
      photoandvideo: image,
    });
    // setFileList(image);
    setdisplayModal(true);
  };

  const onCheckFilterP = (e) => {
    const checked = e.target.checked;
    setpStateFilter(checked);
  };

  function checkSelecthasecternalUrl(value, att) {
    if (
      att.data_dynamic &&
      att.data_dynamic !== undefined &&
      att.data_dynamic !== "" &&
      att.data_dynamic !== "{}"
    ) {
      const rawDatadynamic = JSON.parse(att.data_dynamic);
      if (
        rawDatadynamic.external_url &&
        rawDatadynamic.external_url.length > 0
      ) {
        setexternalUrl(rawDatadynamic.external_url);
      } else {
        setexternalUrl([]);
      }
    }
  }

  function genOption() {
    if (formData.progressDetailType.length > 0) {
      const Optionheaderraw = formData.progressDetailType.filter(
        (data) => JSON.parse(data.data_dynamic).option_type === "group"
      );
      const Optioraw = formData.progressDetailType.filter(
        (data) => JSON.parse(data.data_dynamic).option_type === "label"
      );
      Optionheaderraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).option_seq -
          JSON.parse(b.data_dynamic).option_seq
        );
      });
      Optioraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).option_seq -
          JSON.parse(b.data_dynamic).option_seq
        );
      });
      return (
        <>
          {Optionheaderraw && Optionheaderraw.length > 0
            ? Optionheaderraw?.map((data, index) => (
                <OptGroup
                  label={data.label}
                  key={`Option_progress_index_${index}`}
                >
                  {Optioraw && Optioraw.length > 0
                    ? Optioraw?.map((datas, indexs) => {
                        if (
                          JSON.parse(data.data_dynamic).option_group_id ===
                          JSON.parse(datas.data_dynamic).option_group_id
                        ) {
                          return (
                            <Option
                              key={`progress_detail_form_progress_${
                                indexs + 1
                              }`}
                              value={datas.value}
                              data_dynamic={datas.data_dynamic}
                            >
                              <span className="default-thai-font">
                                {datas.label}
                              </span>
                            </Option>
                          );
                        }
                      })
                    : null}
                </OptGroup>
              ))
            : Optioraw && Optioraw.length > 0
            ? Optioraw?.map((datass, indexss) => (
                <option
                  key={`progress_detail_form_progress_${indexss + 1}`}
                  value={datass.value}
                  data_dynamic={datass.data_dynamic}
                >
                  <span className="default-thai-font">{datass.label}</span>
                </option>
              ))
            : null}
        </>
      );
    }
  }

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      setFileList([...fileList, { ...info.file, action: "ADD" }]);
      console.log("info.file.originFileObj", info);
    }
  };

  const updateJobProgreed = async (values) => {
    const UpdateProgressJob = await ServiceApi.post(
      "JobMaxi/UpdateProgressJob",
      {
        job_id: dataEdit.job_id,
        job_progress_id: dataEdit.job_progress_id,
        job_progress_detail_id: dataEdit.job_progress_detail_id,
        company_id: dataEdit.company_id,
        operator_id: dataEdit.operator_id,
        project_id: dataEdit.project_id,
        activity_id: values.activity_type,
        progress_detail_type_id: values.progress_detail,
        progress_detail: values.progress_details,
        create_by: dataEdit.createby,
      }
    );

    if (UpdateProgressJob.data.result.code === "P") {
      message.success("Save data success");
      setloadingText("Save data success");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } else {
      message.error("Save failed.");
    }
  };
  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
            return reader;
          })
      );

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  const onSendToDtac = async (data, image) => {
    console.log("onSendToDtac", data);
    const result = image.filter(
      (List) =>
        List.reference_id === data.job_progress_detail_id &&
        List.pic_type === "P"
    );
    const formData = new FormData();
    if (result.length > 0) {
      for (let index = 0; index < result.length; index++) {
        var convertFilesType = null;
        convertFilesType = dataURLtoFile(
          await toDataURL(
            ServiceApi.checkPath(
              result[index].pic_url_path,
              result[index].pic_upload_name
            ),
            result[index]["pic_upload_name"]
          ),
          result[index]["pic_upload_name"]
        );
        formData.append("job_id", data.job_id);
        formData.append("job_progress_id", data.job_progress_id);
        formData.append("so_id", data.so_id);
        formData.append("company_id", data.company_id);
        formData.append("operator_id", data.operator_id);
        formData.append("project_id", data.project_id);
        formData.append(
          "JobProgress",
          data.progress_type_Detail + "," + data.progress_detail
        );
        formData.append("files", convertFilesType);
        formData.append("job_progress_detail_id", data.job_progress_detail_id);
        formData.append(
          "PendingCause",
          jobStopTime ? jobStopTime?.job_stop_reason : ""
        );
        formData.append(
          "PendingRemarks",
          jobStopTime ? jobStopTime?.job_stop_remark : ""
        );
        formData.append(
          "PendingTargetDate",
          jobStopTime ? jobStopTime?.job_stop_end : ""
        );
      }
    } else {
      formData.append("job_id", data.job_id);
      formData.append("job_progress_id", data.job_progress_id);
      formData.append("so_id", data.so_id);
      formData.append("company_id", data.company_id);
      formData.append("operator_id", data.operator_id);
      formData.append("project_id", data.project_id);
      formData.append(
        "JobProgress",
        data.progress_type_Detail + "," + data.progress_detail
      );
      formData.append("job_progress_detail_id", data.job_progress_detail_id);
      formData.append(
        "PendingCause",
        jobStopTime ? jobStopTime?.job_stop_reason : ""
      );
      formData.append(
        "PendingRemarks",
        jobStopTime ? jobStopTime?.job_stop_remark : ""
      );
      formData.append(
        "PendingTargetDate",
        jobStopTime ? jobStopTime?.job_stop_end : ""
      );
    }

    await axios({
      method: "post",
      url: process.env.REACT_APP_URL_API + "JobItsm/ProgressJobItsm/",
      data: formData,
      headers: {
        TokenUser: Cookies.get(`OperationToken`),
      },
      processData: false,
    })
      .then(function (response) {
        console.log("formData", formData);
        if (response.data.result.code === "P") {
          message.success("Send data success");
          setloadingText("Send data success");
          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else {
          message.error("Send data failed.");
        }
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  };

  useEffect(() => {
    axios
      .all([
        ServiceApi.post("master_data/activity_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          // MainProcessID: pStateFilter ? jobDetail?.mainProcessID : null,
          // SubProcessID: pStateFilter ? jobDetail?.subProcessID : null,
        }),
        ServiceApi.post("master_data/job_progress_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: jobDetail?.job_type_id,
          MainProcessID: pStateFilter ? jobDetail?.mainProcessID : null,
          SubProcessID: pStateFilter ? jobDetail?.subProcessID : null,
        }),
      ])
      .then(([resActivity, resProgressType]) => {
        const { data: resultActivity } = resActivity;
        const { data: resultProgressType } = resProgressType;
        const activityList = resultActivity?.data.result.map((s) => ({
          ...s,
          value: s.activity_id,
          label: s.activity_name,
        }));
        const progressTypeList = resultProgressType?.data.result.map((s) => ({
          ...s,
          value: s.progress_type_id,
          label: s.progress_type_name,
        }));
        setFormData({
          ...formData,
          activityType: activityList,
          progressDetailType: progressTypeList,
        });

        // console.log("res2", resultProgressType);
        // console.log("authUser", auth);
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pStateFilter]);

  return (
    <>
      <div className="col my-2 px-2">
        <Collapse
          className="container"
          collapsible="disabled"
          defaultActiveKey={["1"]}
        >
          <Panel
            showArrow={false}
            header={
              <div className="font-thai-b fs-18">
                <span className="c-blue text-uppercase">{`Job Progress Record`}</span>
              </div>
            }
            key="1"
            extra={genDownloadCSV()}
            className="font-thai-r fs-18 my-0"
            style={{minHeight:100}}
          >
            <Spin spinning={loading} tip="Loading...">
              {jobProgressHistory.map((data, index) => (
                <div key={`job_progress_detail_${index}`} className="card mb-2">
                  {Jobprocesscard(data, jobProgressPic)}
                  <div className="row">
                    <div
                      className="col-12 mb-2 mt-2"
                      style={{ textAlign: "center" }}
                    >
                      {!data.isSendToDtac &&
                      (Cookies.get(`usergroupname`) === "MCC" ||
                        Cookies.get(`usergroupname`) === "MM (Center)" ||
                        Cookies.get(`usergroupname`) === "MM (Lead)" ||
                        Cookies.get(`usergroupname`) === "ADMIN" ||
                        Cookies.get(`usergroupname`) === "NE (Center)") ? (
                        <>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            onClick={() => onEdit(data, jobProgressPic)}
                          >
                            Edit Progress
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary"
                            onClick={() => onSendToDtac(data, jobProgressPic)}
                          >
                            Send To Dtac
                          </button>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              ))}
            </Spin>
          </Panel>
        </Collapse>

        <Modal
          title="EDIT JOB PROGRESS FORM"
          visible={displayModal}
          width={800}
          style={{ top: "10px" }}
          footer={false}
          onCancel={() => setdisplayModal(false)}
        >
          <div className="d-flex align-content-md-start flex-wrap w-100">
            <div className="col col-12">
              <Form
                name="job_progress_form"
                onFinish={updateJobProgreed}
                form={form}
                {...defaultFormItemLayout}
              >
                <Form.Item
                  name="activity_type"
                  label="Activity Type :"
                  rules={[
                    { required: true, message: "Activity Type is required" },
                  ]}
                >
                  <Select placeholder="Select">
                    {formData.activityType.map((data, index) => (
                      <Option
                        key={`activity_type_form_progress_${index + 1}`}
                        value={data.value}
                      >
                        <span className="default-thai-font">{data.label}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="progress_detail"
                  label="Progress Detail : "
                  rules={[
                    { required: true, message: "Progress Detail is required" },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    onChange={checkSelecthasecternalUrl.bind(this)}
                  >
                    {formData.progressDetailType.length > 0
                      ? genOption()
                      : null}
                  </Select>
                </Form.Item>
                <div className="row">
                  <div style={{ marginLeft: "26%" }}>
                    <Checkbox onChange={onCheckFilterP}>
                      Filter by P-Stage
                    </Checkbox>
                  </div>
                </div>
                <Form.Item name="progress_details" label="Progress Details : ">
                  <Input.TextArea rows="5"></Input.TextArea>
                </Form.Item>
                {/* <Form.Item label="Photo and Video" name="photoandvideo">
                  <Form.Item
                    style={{ border: "1px solid #d9d9d9", padding: 10 }}
                  >
                    <Upload
                      name="image"
                      // showUploadList={false}
                      listType="picture-card"
                      className="avatar-uploader"
                      action={`${process.env.REACT_APP_URL_API}mockupupload/`}
                      // beforeUpload={beforeUpload}
                      onChange={handleChange}
                    >
                      {fileList.length >= 8 ? null : (
                        <div style={{ marginTop: 8 }}>Upload</div>
                      )}
                    </Upload>
                  </Form.Item>
                </Form.Item> */}
                {/* <Form.Item {...tailLayout}> */}
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      form.resetFields();
                      // setDisableSubmit(false);
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => form.submit()}
                  >
                    Save
                  </button>
                </div>
                {/* </Form.Item> */}
              </Form>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
